import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useImperativeHandle, useState } from 'react'
import { Tab } from '@headlessui/react'

import ProcureLargeDesktop from 'assets/image/our-solution/procure-large-desktop.png'
import SupplyLargeDesktop from 'assets/image/our-solution/supply-large-desktop.png'

import ProcureDesktop from 'assets/image/our-solution/procure.png'
import RetailDesktop from 'assets/image/our-solution/retail.png'
import SupplyDesktop from 'assets/image/our-solution/supply.png'

import ProcureTablet from 'assets/image/our-solution/procure-tablet.png'
import RetailTablet from 'assets/image/our-solution/retail-tablet.png'
import SupplyTablet from 'assets/image/our-solution/supply-tablet.png'

import RetailTab from 'assets/svg/solution/Retail'
import ProcureTab from 'assets/svg/solution/Procure'
import SupplyTab from 'assets/svg/solution/Supply'

import TabSolution from './TabSolution/TabSolution'
import PanelSolution from './TabSolution/PanelSolution'

const OurSolution = ({ refTab }) => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [categories] = useState({
    'Manuva Retail': {
      id: 'retail',
      tab: RetailTab,
      content: {
        title: 'Solution for Retailers',
        description:
          'Connecting SME manufacturers to retailers. Helping thousands of retailers stock their inventory with the best price possible and fast delivery.',
        image: {
          largeDesktop: RetailDesktop,
          desktop: RetailDesktop,
          tablet: RetailTablet
        },
        listDetails: [
          'Selection of inventory with more than 400 SKUs.',
          'Get the best price from our manufacturers.',
          'Fast and reliable fulfillment.'
        ]
      }
    },
    'Manuva Procure': {
      id: 'procure',
      tab: ProcureTab,
      content: {
        title: 'B2B E-Procurement Platform for managing your print and packaging vendors',
        description: 'Bringing reliability to your procurement process with the best price, timeline and quality.',
        image: {
          largeDesktop: ProcureLargeDesktop,
          desktop: ProcureDesktop,
          tablet: ProcureTablet
        },
        listDetails: [
          'Manage multiple vendors and SKUs.',
          'Manage payment seamlessly and get the best price through our financing solution.',
          'Control your production timeline and quantity.'
        ]
      }
    },
    'Manuva Supply': {
      id: 'supply',
      tab: SupplyTab,
      content: {
        title: 'Integrate your Order Management Process in One Single Platform',
        description:
          'Provide a better service for customers by creating quotations, handling orders, arranging deliveries, invoicing, and many more just in one single platform.',
        image: {
          largeDesktop: SupplyLargeDesktop,
          desktop: SupplyDesktop,
          tablet: SupplyTablet
        },
        listDetails: [
          'Increase your production utilization.',
          'Get Early Payment.',
          'Get Raw Materials with the best prices.'
        ]
      }
    }
  })

  useImperativeHandle(refTab, () => ({

    setSelectedIndexTab (index) {
      setSelectedIndex(index)
    }

  }))

  return (
    <section id="our-solution" className="bg-[#071126]">
      <div className={clsx(
        `relative py-10 px-6 max-w-[1440px] m-auto left -0 right-0
        lg:px-14 lg:pt-20
        xl:pl-[223px] xl:pr-[195px] xl:pt-[88px]`,
        selectedIndex === 0 && 'lg:pb-[100px] xl:pb-[88px]',
        selectedIndex === 1 && 'lg:pb-[88px] xl:pb-[94px]',
        selectedIndex === 2 && 'lg:pb-[90px] xl:pb-[104px]'
      )}>
        <div>
          <h1 className={clsx(
            'text-white font-bold leading-[140%] text-[28px] lg:text-[40px] w-fit m-auto left-0 right-0'
          )}>Our Solutions</h1>
        </div>

        <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
          <Tab.List className="flex w-[327px] justify-between lg:w-[725px] gap-x-2.5 lg:gap-x-6 rounded-[40px] bg-white/[0.08] p-1 mt-10 lg:mt-[44px] m-auto left-0 right-0">
            <TabSolution categories={categories}/>
          </Tab.List>
          <Tab.Panels className="mt-2">
            <PanelSolution categories={categories}/>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </section>
  )
}

OurSolution.propTypes = {
  refTab: PropTypes.node
}

export default OurSolution
